import { render, staticRenderFns } from "./PropertyBlock.vue?vue&type=template&id=d0429d30&scoped=true"
import script from "./PropertyBlock.vue?vue&type=script&lang=ts"
export * from "./PropertyBlock.vue?vue&type=script&lang=ts"
import style0 from "./PropertyBlock.vue?vue&type=style&index=0&id=d0429d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0429d30",
  null
  
)

export default component.exports